module.exports = __webpack_public_path__ + "static/pixelpin-c6d1bd7cd01dd8e5cd0ec072467293e0.png";